import { z } from "zod";

import { ConfigurationResponseDtoSchema } from "../../../dtos/configurations";
import { OrganizationDtoSchema } from "../../../dtos/organizations";
import { JsonSchema } from "../../../utils";

const ConfigurationSchema = z.object({
  key: z.string(),
  value: JsonSchema,
});

export const EditConfigurationsRequestBodySchema = ConfigurationSchema.array();

export type EditConfigurationsRequestBodyType = z.infer<
  typeof EditConfigurationsRequestBodySchema
>;

export const EditConfigurationsResponseBodySchema = z.object({
  configurations: ConfigurationResponseDtoSchema.array(),
});

export type EditConfigurationsResponseBodyType = z.infer<
  typeof EditConfigurationsResponseBodySchema
>;
